var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-container"},[_c('label',{attrs:{"for":_vm.randomIdKey}},[_c('input',{attrs:{"type":"checkbox","id":_vm.randomIdKey},domProps:{"checked":_vm.isChecked},on:{"click":function($event){return _vm.$emit('updateValue', _vm.value)}}}),_vm._v(" "),_c('span',{staticClass:"checkbox"},[_c('Checkmark')],1),_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bed90b6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-elements/Checkbox.vue
// module id = null
// module chunks = 